import { call, put } from "redux-saga/effects";
import { MLAPI } from "api";
import * as Actions from "UserAuthorized/actionTypes";

export function* saveAction(action) {
  const { response, error } = yield call(
    MLAPI.action.saveAction,
    action.payload
  );
  if (response) {
    yield put({
      type: Actions.ACTION_SAVE_ACTION_SUCCESSFUL,
      payload: { success: response.data.status === "Success" }
    });
  } else
    yield put({
      type: Actions.ACTION_SAVE_ACTION_ERROR,
      payload: error
    });
}
